import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { TelemetryService } from './telemetry.service';

/**
 * Returns the providers Cassiopeia apps need to enable browser telemetry.
 *
 * Pair with `initializeTelemetry({...})` called once at bootstrap before
 * `bootstrapApplication`. This helper only sets up the Angular DI side
 * (eager TelemetryService construction).
 */
export function provideTelemetry(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideAppInitializer(() => {
      // A rejected app initializer is a blank page, and no trace is worth that.
      try {
        inject(TelemetryService);
      } catch (error) {
        console.error('Telemetry service initialization failed, continuing without telemetry', error);
      }
    }),
  ]);
}
